import { Client } from '@/manager/client/client.model';
import { Employee } from '@/shared/models/employee.model';
import { Convocation } from '@/manager/convocation/convocation.model';
import { TypeOfProduct } from '@/manager/product/models/product.model';
import { LocationInterface } from '@/shared/interfaces/location.interface';
import { TimetablesInterface } from '@/shared/interfaces/timetables.interface';


export interface SaleInfoProductInterface {
    id?: number;
    base?: number;
    byHour?: number;
    conference?: number;
    course?: number;
    daysOfDuration?: number;
    delegation?: any;
    description?: string;
    level?: number;
    location?: any;
    name?: string;
    postponemets?: number;
    reEnroll?: number;
    repeat?: number;
    typeOfProduct?: TypeOfProduct;
    bono?: number;
}

export interface SaleInfoInterface {
    id?: string;
    product?: SaleInfoProductInterface;
    location?: LocationInterface;
    timetables?: TimetablesInterface[];
}

export class SaleInfo implements SaleInfoInterface {
    public id?: string;
    public product?: SaleInfoProductInterface;
    public location?: LocationInterface;
    public timetables?: TimetablesInterface[];
}
